import GenericModel from '../generic-model';
import { ProjectPlacement } from './projectPlacement';
import { Pickup } from './pickup';
import { User } from '../user';
import ProjectInvoice from '../invoice/project-invoice';
import Employee from '../product/employee';
import { ProjectDto } from './projectDto';
import Quotation from '../quotation';
import ProductAsset from '../product-asset';
import LoggedAction from '../logged-action';
import Address from './address';
import { TourItem } from '../tour/tour-item';
import { NotExecutedHistoryItem } from '../history-item/not-executed-history-item';
import Asset from '../asset';
import SubProjectContact from '../company/subProjectContact';

export class SubProject extends GenericModel {
  archived?: boolean;
  project?: ProjectDto;
  type?: string;
  createdAt?: Date;
  status?: string;
  withPlacement?: boolean;
  withPlacementNotes?: string;
  pickup?: Pickup;
  projectPlacement?: ProjectPlacement;
  projectUser?: User;
  projectInvoices?: ProjectInvoice[];
  needsInvoice?: boolean;
  extraInfoInvoice?: string;
  thankYouMailSent?: boolean;
  currentRequestDate?: Date;
  currentRequestASAP?: boolean;
  currentExecutionDate?: Date;
  currentCreatedAt?: Date;
  currentDesignDate?: Date;
  currentDesignASAP?: boolean;
  currentPrintDate?: Date;
  currentPrintASAP?: boolean;
  currentFinishDate?: Date;
  currentFinishASAP?: boolean;
  currentSiteVisitDate?: Date;
  currentConfirmedPlacementDate?: Date;
  subStatuses?: string[];
  displayStatus?: string;
  pending?: boolean;
  pendingImportant?: boolean;
  quotationImportant?: boolean;
  quotationHandler?: Employee;
  quotationByDate?: Date;
  quotationComments?: string;
  needsQuotation?: boolean;
  currentRequestDateDay?: Date;
  siteVisitImportant?: boolean;
  quotation: Quotation;
  quotationSent: boolean;
  quotationSentResetReason?: string;
  quotationFollowed?: boolean;
  invoiceHandler?: Employee;
  fromOldSystem?: boolean;
  delayed?: boolean;
  delayedReason?: string;
  delayedRegistration?: LoggedAction;
  delayHandler?: Employee;
  handleDelayByDate?: Date;
  onHold?: boolean;
  onHoldReason?: string;
  onHoldHandling?: string;
  putOnHold?: LoggedAction;
  onHoldHandled?: LoggedAction;
  mostRecentlyExecutedProductAssets?: ProductAsset[];
  tourItem?: TourItem;
  invoiceAsNonExecuted?: boolean;
  appointmentBlocksTourAssignment?: boolean;
  subProjectContact?: SubProjectContact;

  // needsDesign: boolean;
  // adjustmentDesigner: Employee;
  // designApproved: boolean;
  // designSentToCustomer: boolean;
  // designFinished: boolean;
  // needPrintwork: boolean;
  // printWorkReady: boolean;
  // needFinish: boolean;
  // finishReady: boolean;

  // Only for display in project table
  quotationBackgroundClass?: string;
  quotationBadgeIcon?: any;
  designBackgroundClass?: string;
  designBadgeIcon?: any;
  printJobBackgroundClass?: string;
  printJobBadgeIcon?: any;
  finishBackgroundClass?: string;
  finishBadgeIcon?: any;
  placementBackgroundClass?: string;
  placementBadgeIcon?: any;
  displayQuotationDate?: string;
  displayPlacerNotes?: string;
  collectKeyFromAddress?: string;
  needExternalSupplier?: boolean;
  applyGreenBackground?: boolean;

  // Only for display in project form
  showExecutedCheck?: boolean;

  // Only for display in admin planning map popup
  popupDisplay?: string;
  planned?: boolean;

  // Only for display in client corner map
  clientDisplayStatus?: string;
  clientCornerPlacerNames?: string;
  stickerText?: string;

  // Only for display in tour item list
  appointmentTime?: string;
  appointmentTooltip?: string;
  typeDisplay?: string;
  typeClass?: string;
  displayAsExecuted?: boolean;

  // Only for tour page
  address?: Address;
  onStones?: boolean;
  withAppointment?: boolean;
  hasSecondBoard?: boolean;

  approved: boolean;
  approvedRegistration?: LoggedAction;

  internalInfo?: string;
  recurringInternalInfo?: boolean;

  latestNotExecutedHistoryItem?: NotExecutedHistoryItem;

  // placer frontend only
  designPictures?: Asset[];
  latestExecutionAssets?: ProductAsset[];

  constructor(id?: number) {
    super();
    if (id != null) {
      this.id = id;
    }
    this.projectPlacement = new ProjectPlacement();
    this.pickup = new Pickup();
    this.status = 'Nieuw';
    this.displayStatus = 'Nieuw';
    this.pendingImportant = false;
    this.quotationImportant = false;
    this.siteVisitImportant = false;
    this.withPlacement = true;
  }
}

export enum SUB_PROJECT_TYPES {
  BASE_PROJECT = 'BaseProject',
  ADJUSTMENT = 'Adjustment',
  SOLDRENTED = 'SoldRented',
  REPO = 'Repo',
}

export const TypeToDisplayAndClass: Map<string, SubProjectTypeDisplayAndClass> =
  new Map<string, SubProjectTypeDisplayAndClass>([
    [
      SUB_PROJECT_TYPES.BASE_PROJECT,
      {
        display: 'Plaatsing',
        class: 'plaatsing',
      },
    ],
    [
      SUB_PROJECT_TYPES.ADJUSTMENT,
      {
        display: 'Aanpassing',
        class: 'aanpassing',
      },
    ],
    [
      SUB_PROJECT_TYPES.SOLDRENTED,
      {
        display: 'Verkocht/Verhuurd',
        class: 'verkocht-verhuurd',
      },
    ],
    [
      SUB_PROJECT_TYPES.REPO,
      {
        display: 'Weggehaald',
        class: 'weghalen',
      },
    ],
  ]);

export interface SubProjectTypeDisplayAndClass {
  display: string;
  class: string;
}
